export class UserType {
    private _code: number = -1;
    private _type: string = "";
    private _alphaCode: string = "";
    private _description: string = "";

    public static createUserTypes(types: string[]): UserType[] {
        let userTypes = [];

        if (types.includes("employee")) {
            const userType = new UserType();
            userType.code = 1;
            userType.type = "employee";
            userType.description = "Employee";
            userTypes.push(userType);
        }

        if (types.includes("dealer")) {
            const userType = new UserType();
            userType.code = 2;
            userType.type = "dealer";
            userType.description = "Dealer";
            userTypes.push(userType);
        }

        if (types.includes("dealer-rep")) {
            const userType = new UserType();
            userType.code = 3;
            userType.type = "dealer-rep";
            userType.description = "Dealer Rep";
            userTypes.push(userType);
        }

        if (types.includes("dealer/dealer-rep")) {
            const userType = new UserType();
            userType.code = 2;
            userType.type = "dealer";
            userType.description = "Dealer / Dealer Rep";
            userTypes.push(userType);
        }

        if (types.includes("customer")) {
            const userType = new UserType();
            userType.code = 4;
            userType.type = "customer";
            userType.description = "Customer";
            userTypes.push(userType);
        }

        return userTypes; 
    }

    public get code(): number {
        return this._code;
    }

    public set code(value: number) {
        this._code = value;
    }

    public get type(): string {
        return this._type;
    }

    public set type(value: string) {
        this._type = value;
    }

    public get alphaCode(): string {
        return this._alphaCode;
    }

    public set alphaCode(value: string) {
        this._alphaCode = value;
    }

    public get description(): string {
        return this._description
    }

    public set description(value: string) {
        this._description = value;
    }
}    
